import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScriptInjectorService } from '../../../core/services/script-injector.service';
import { environment } from '../../../../environments/environment';
import { BeaconChatService } from '../../../core/services/beacon-chat.service';
import * as fromRoot from '../../../reducers';
import * as fromAuth from '../../../auth/reducers';

@Component({
  selector: 'portal-video-call-page',
  templateUrl: 'video-call-page.container.html',
  styleUrls: ['./video-call-page.container.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VideoCallPageComponent implements OnInit, OnDestroy {
  public clinicVideoCallLoaded$: Observable<boolean>;
  public videoCallEnabled$: Observable<boolean>;
  public videoCallId$: Observable<string | null>;
  public selectedLanguage$: Observable<string | null>;
  public xSalveClinicToken$: Observable<string | null>;
  private originalPadding: string | null = null;

  constructor(
    private _store: Store<fromRoot.State>,
    private _elementRef: ElementRef,
    private _route: ActivatedRoute,
    private _scriptInjector: ScriptInjectorService,
    private _renderer: Renderer2,
    private _beaconChatService: BeaconChatService
  ) {}

  ngOnInit() {
    this._beaconChatService.hideBeaconChat();
    // Override mat-sidenav-content padding
    const sidenavContent = document.querySelector('.mat-sidenav-content');
    if (sidenavContent) {
      this.originalPadding = sidenavContent.getAttribute('style');
      this._renderer.setStyle(sidenavContent, 'padding', '0px');
      // Add a class that we can target with !important in our CSS
      this._renderer.addClass(sidenavContent, 'video-call-active');
    }
    this.videoCallId$ = from(
      this._route.paramMap.pipe(
        map((params) => {
          const id = params.get('id');
          // != null catches null or undefined
          if (id != null) {
            return String(id);
          }
          return null;
        })
      )
    );
    this.videoCallEnabled$ = this._store.pipe(
      select(fromAuth.getVideoCallsEnabled)
    );
    this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
    this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
    this.clinicVideoCallLoaded$ = from(
      this._scriptInjector
        .loadScript(
          'salve-clinic-video-call',
          environment.videoCallComponentUrl
        )
        .then(() => true)
        .catch(() => false)
    );
  }

  ngOnDestroy(): void {
    this._beaconChatService.showBeaconChat();

    // Restore original padding if it existed
    const sidenavContent = document.querySelector('.mat-sidenav-content');
    if (sidenavContent) {
      // Remove our special class
      this._renderer.removeClass(sidenavContent, 'video-call-active');

      if (this.originalPadding) {
        this._renderer.setAttribute(
          sidenavContent,
          'style',
          this.originalPadding
        );
      } else {
        this._renderer.removeStyle(sidenavContent, 'padding');
      }
    }
  }
}
